var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { ContentPadding } from '@project/components/base';
import { PageContent } from '@project/components/Page';
import { P } from '../../components/UI-helpers/typography';
import { Input, Label, Checkbox } from '../../components/Forms/Fields';
import ButtonLink from '../../components/ButtonLink';
import { colors } from '../../components/UI-helpers/colors';
import SelectForModal from '../../components/Forms/Fields/SelectForModal';
import FilterDataset from '../../components/FilterDataset';
import VariableCreator from '../../components/VariableCreator';
import ExperimentComponent from '../../components/ExperimentComponent';
import { CheckboxWrapper } from './styles';
var CreateRuleDialog = function (props) {
    var _a = useState([]), actions = _a[0], setActions = _a[1];
    var _b = useState(''), ruleName = _b[0], setRuleName = _b[1];
    var _c = useState('true'), conditions = _c[0], setConditions = _c[1];
    var _d = useState(''), filters = _d[0], setFilters = _d[1];
    var _e = useState([]), variables = _e[0], setVariables = _e[1];
    var _f = useState([]), groups = _f[0], setGroups = _f[1];
    useEffect(function () {
        if (!props.rule)
            return;
        setRuleName(props.rule.name);
        setGroups(props.rule.groups.map(function (_a) {
            var id = _a.id, label = _a.label;
            return ({
                id: id,
                value: id,
                label: label,
                name: label,
            });
        }));
        setConditions(props.rule.conditions);
        setFilters(props.rule.filters);
        setActions(props.rule.actions);
        setVariables(props.rule.variables);
    }, [props.rule]);
    var onUpdateRule = function () {
        var _a;
        props.onUpdateClick &&
            props.onUpdateClick({
                id: (_a = props.rule) === null || _a === void 0 ? void 0 : _a.id,
                name: ruleName,
                groupIds: groups.map(function (item) { return item.value; }),
                conditions: conditions,
                filters: filters,
                variables: variables,
                actions: actions,
            });
    };
    var onSaveRule = function () {
        props.onSaveClick({
            name: ruleName,
            groupIds: groups.map(function (item) { return item.value; }),
            conditions: conditions,
            filters: filters,
            variables: variables,
            actions: actions,
        });
    };
    var checkItem = function (item) {
        var newArr = [];
        if (!actions.includes(item)) {
            if (item === 'multi-read') {
                // if multi-read is checked, uncheck all other actions
                newArr = [item];
            }
            else {
                // if non multi-read, clear filters
                setFilters('');
                newArr = __spreadArray(__spreadArray([], actions, true), [item], false);
            }
        }
        else {
            newArr = actions.filter(function (a) { return a !== item; });
        }
        setActions(newArr);
    };
    var isValid = function () {
        return !!(ruleName && actions.length > 0 && (groups === null || groups === void 0 ? void 0 : groups.length) > 0);
    };
    var isMultiRead = actions.includes('multi-read');
    var columnsWithId = (props === null || props === void 0 ? void 0 : props.columns)
        ? __spreadArray(__spreadArray([], props === null || props === void 0 ? void 0 : props.columns, true), [{ name: 'id', type: 'string' }], false) : [{ name: 'id', type: 'string' }];
    return (_jsxs(_Fragment, { children: [_jsx("div", { children: _jsx(P, __assign({ black: true, bold: true, center: true, fontSize: 22 }, { children: props.rule ? 'Update Rule' : 'Create Rule' })) }), _jsx(PageContent, __assign({ modal: true }, { children: _jsxs(ContentPadding, __assign({ centered: true, noHeight: true }, { children: [_jsxs("div", __assign({ className: "flex flex-col" }, { children: [_jsx(Label, { children: "Name" }), _jsx(Input, { value: ruleName, onChange: function (_a) {
                                        var target = _a.target;
                                        return setRuleName(target.value);
                                    } })] })), _jsxs("div", __assign({ className: "flex flex-col mb-2" }, { children: [_jsx(Label, { children: "Groups" }), _jsx("div", __assign({ className: "mt-2" }, { children: _jsx(SelectForModal, { name: "type", value: groups, options: props.groups.map(function (t) { return ({
                                            value: t.id,
                                            label: t.label,
                                        }); }), multiple: true, isMulti: true, placeholder: "Select Group", onChange: function (option) { return setGroups(option); } }) }))] })), _jsx(Label, { children: "Actions" }), _jsxs(CheckboxWrapper, __assign({ isSystemDs: !props.isNotSystemDs }, { children: [_jsx(Checkbox, { checked: isMultiRead, label: "Multi-Read", onChange: function () { return checkItem('multi-read'); } }), props.isNotSystemDs && (_jsx(Checkbox, { checked: actions.includes('create'), label: "Create", onChange: function () { return checkItem('create'); }, disabled: isMultiRead })), _jsx(Checkbox, { checked: actions.includes('read'), label: "Read", onChange: function () { return checkItem('read'); }, disabled: isMultiRead }), props.isNotSystemDs && (_jsxs(_Fragment, { children: [_jsx(Checkbox, { checked: actions.includes('update'), label: "Update", onChange: function () { return checkItem('update'); }, disabled: isMultiRead }), _jsx(Checkbox, { checked: actions.includes('delete'), label: "Delete", onChange: function () { return checkItem('delete'); }, disabled: isMultiRead })] }))] })), _jsxs("div", __assign({ className: "flex flex-col mb-2" }, { children: [_jsx(Label, { children: "Variables" }), _jsx(VariableCreator, { buttonTitle: "Variables", variables: variables, onUpdateVariable: function (name, type, defaultValue) {
                                        return setVariables(__spreadArray(__spreadArray([], variables, true), [
                                            { name: name, type: type, default: defaultValue },
                                        ], false));
                                    }, onDeleteVariable: function (name) {
                                        return setVariables(variables.filter(function (variable) { return variable.name !== name; }));
                                    }, onClearVariables: function () { return setVariables([]); } })] })), _jsxs("div", __assign({ className: "flex flex-col mb-2" }, { children: [_jsx(Label, { children: "Filters" }), _jsx(FilterDataset, { queryString: filters, columns: columnsWithId, onFilterUpdate: function (e) { return setFilters(e); }, disablePopup: true, disabled: !isMultiRead, isRule: true })] })), _jsx(ExperimentComponent, { name: "DATASET_RULES", Experiment: _jsxs("div", __assign({ className: "flex flex-col mb-2" }, { children: [_jsx(Label, { children: "Conditions" }), _jsx(Input, { value: conditions, onChange: function (_a) {
                                            var target = _a.target;
                                            return setConditions(target.value);
                                        } })] })) }), _jsx("div", __assign({ className: "flex flex-row justify-end w-full mt-4" }, { children: props.rule ? (_jsx(ButtonLink, __assign({ disabled: !isValid(), onClick: onUpdateRule }, { children: _jsx(P, __assign({ color: colors.primary, bold: true }, { children: "Update" })) }))) : (_jsx(ButtonLink, __assign({ disabled: !isValid(), onClick: onSaveRule }, { children: _jsx(P, __assign({ color: colors.primary, bold: true }, { children: "Save" })) }))) }))] })) }))] }));
};
export default CreateRuleDialog;
